@if (attribute) {
  <div class="attribute-grid">
    <div class="attribute-label">
      <app-copy-to-clipboard
        class="md:pr-4"
        value="{{label}}: {{ getSelectedValue(attribute) }}"
        >
        {{label}}
      </app-copy-to-clipboard>
    </div>
    <div [class.hidden]="ngControl.disabled">
      <ng-select [formControl]="$any(ngControl.control)" [items]="options" bindValue="key" [multiple]="attribute.multiple"
        bindLabel="value"
        class="min-w-[12.5rem]">
      </ng-select>
    </div>
    <div class="mb-2 flex items-center w-full rounded md:mb-0 md:min-h-12 md:px-4 block"
      [class.hidden]="!ngControl.disabled">
      <app-copy-to-clipboard value="{{ getSelectedValue(attribute) }}">
        {{ getSelectedValue(attribute) }}
      </app-copy-to-clipboard>
    </div>
  </div>
}
